import { render, staticRenderFns } from "./Paid.vue?vue&type=template&id=0dec8a67&scoped=true"
import script from "./Paid.vue?vue&type=script&lang=js"
export * from "./Paid.vue?vue&type=script&lang=js"
import style0 from "./Paid.vue?vue&type=style&index=0&id=0dec8a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec8a67",
  null
  
)

export default component.exports